import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './components/app';
import { loadTracing } from './common/utils/loadTracing';

const container = document.querySelector('#client-app');
if (container) {
  loadTracing();
  const root = createRoot(container);
  root.render(<App />);
} else {
  throw Error('The provided root is not in the document');
}
